import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { TranslateService } from "@ngx-translate/core";
import { Table } from 'primeng/table';

// Mock data
import { mockSTranslationMapping } from '@src/assets/data/translation-mapping.mock';
import { SessionService } from '@src/app/shared/services/session.service';

@Component({
    selector: 'app-translations-settings',
    templateUrl: './translations-settings.component.html',
    styleUrls: ['./translations-settings.component.scss'],
    host: {
        class: 'app-translations-settings'
    },
    standalone: false
})
export class TranslationsSettingsComponent implements OnInit {

  displayTranslationDataModalbox: boolean = false;
  languages: Array<{ language: string, code: string, isEnabled: boolean }> = [];

  @ViewChild('dtTranslationsTable') table: Table | undefined;
  translationsList = mockSTranslationMapping;
  translationDetails: any;

  translationKey: string | undefined;
  systemValue: string | undefined;

  public translationsSettingsFormGroup: FormGroup;

  constructor(
    private session: SessionService,
    private translate: TranslateService,
    private fb: FormBuilder
  ) {
    this.translationsSettingsFormGroup = this.fb.group({
      defaultLang: ['en']
    });
  }

  ngOnInit() {
    const data = this.getTranslationData();
    this.translationDetails = data?.translationsArray;
    this.systemValue = data?.systemValue;

    this.initForm();
  }

  initForm() {
    this.getLanguages();

    // Dynamically add controls for each enabled language
    this.languages.forEach(lang => {
      if (!this.translationsSettingsFormGroup.contains(lang.code)) {
        this.translationsSettingsFormGroup.addControl(
          lang.code,
          new FormControl(lang.isEnabled)
        );
      }
    });
  }

  private getLanguages() {
    const rawLanguages = this.session.companySettings?.languages ?? [];
    const enabledLanguages = rawLanguages.filter(language => language.isEnabled);

    const translation = this.translate.instant('PORTAL_LANGUAGES');

    this.languages = enabledLanguages.map(lang => {
      const code = lang.code || 'unknown';
      const label = code ? translation[code.toUpperCase()] || code.toUpperCase() : 'Unknown';
      return {
        language: label,
        code,
        isEnabled: lang.isEnabled ?? false
      };
    });

  }

  getTranslationData() {
    const data = {
      code: '1',
      translationKey: 'SERIAL_NUMBER',
      systemValue: 'Serial number',
      translations: {
        en: 'Serial number',
        fr: 'Numéro de série',
        de: 'Seriennummer',
        es: 'Número de serie',
        it: 'Numero di serie',
        ja: 'シリアルナンバー',
        ko: '일련번호',
        zh: '序列号',
        zhtw: '序號',
        ar: 'رقم سري',
        ru: 'Серийный номер'
      }
    };

    const languageMap = {
      en: 'English',
      fr: 'French',
      de: 'German',
      es: 'Spanish',
      it: 'Italian',
      ja: 'Japanese',
      ko: 'Korean',
      zh: 'Chinese (Simplified)',
      zhtw: 'Chinese (Traditional)',
      ar: 'Arabic',
      ru: 'Russian'
    };

    // Convert the translations object into an array with full language names
    const translationsArray = Object.keys(data.translations).map(language => ({
      language: languageMap[language as keyof typeof languageMap],
      translation: data.translations[language as keyof typeof data.translations]
    }));

    return {
      translationsArray,
      translationKey: data.translationKey,
      systemValue: data.systemValue
    };
  }

  openTranslationDetails(event: any, translationId: string) {
    this.displayTranslationDataModalbox = true;
    // To-Do call backend to get the translations of the given translation key
    // ...
    this.translationDetails = this.getTranslationData(); // Mocked data for now
  }

  updateTranslationsSettings() {
    if (this.translationsSettingsFormGroup.valid) {
      // console.log('Settings saved!', this.translationsSettingsFormGroup.value);
      // TODO: Send updated settings to backend
    }
  }

  onCancelTranslationDetailsUpdate() {
    this.displayTranslationDataModalbox = false;
  }

  onUpdateTranslationDetails() {
    this.displayTranslationDataModalbox = false;
    // To-DO: Call change retailer state endpoint
    // ...
    // TODO: Call API to persist updated translations
  }

}
